import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useUser } from "@supabase/auth-helpers-react";

export interface CompanySubscription {
  subscribed: boolean;
  plan_type?: "core" | "plus";
  jobs_limit?: number;
  jobs_used?: number;
  highlights_limit?: number;
  highlights_used?: number;
  current_period_end?: string;
  stripe_subscription_id?: string;
}

export function useCompanySubscription() {
  const user = useUser();

  return useQuery<CompanySubscription>({
    queryKey: ["company-subscription", user?.id],
    queryFn: async () => {
      const { data, error } = await supabase.functions.invoke("check-company-subscription");
      if (error) throw error;
      return data as CompanySubscription;
    },
    enabled: !!user?.id,
    staleTime: 1000 * 60 * 2,
    refetchInterval: 1000 * 60, // every minute
  });
}
